<template>
    <div v-if="showDeposit" class="containerDeposit">
        <UseDialog :title="l('ck')" :closeCallBack="closeCallBack" width="605">
            <template #content>
                <div v-loading="loading" class="content">
                    <p class="font18" style="color:#39270c;">{{l('zffs')}}</p>
                    <div class="rechargeMethod flex warp">
                        <p @click="changePayMentMethodFn(index)" v-for="(item,index) in paymentMethod" :key="index"
                           :class="{currentRechargeMethod:currentPaymentMethod === index}"
                           class="font16 pointer bold flex alignItemsCenter justifyContentCenter">{{item.label}}</p>
                    </div>
                    <div class="paymentChannels">
                        <p class="font16" style="color:#39270c;">{{l('zfqd')}}</p>
                        <div class="channels flex warp">
                            <p @click="changePaymentChannelFn(index)" v-for="(item,index) in paymentChannel.list"
                               :key="index" :class="{currentRechargeMethod:index === paymentChannel.current}"
                               class="font14 pointer flex column alignItemsCenter justifyContentCenter">
                                <span>{{item.name}}</span>
                                <span>{{item.label}}</span>
                            </p>
                            <p @click="toOnlineService"
                               class="font14 pointer flex column alignItemsCenter justifyContentCenter">
                                <span>人工支付</span>
                            </p>
                        </div>
                        <p class="font16" style="color:#39270c;margin-top:30px;">{{l('ckje')}}（{{goldUnit()}}）</p>
                        <div style="margin-top: 20px;">
                            <template v-if="paymentChannel.list[paymentChannel.current]?.payAmount.length > 2">
                                <div class="chooseMoney flex textAlignCenter">
                                    <p @click="quickAmountFn(item,index)"
                                       v-for="(item,index) in paymentChannel.list[paymentChannel.current]?.payAmount"
                                       :key="index"
                                       :class="{currentMoney:index === quickAmount.current && item === formData.money}"
                                       class="pointer">{{item}}</p>
                                </div>
                            </template>
                            <template v-if="paymentChannel.list[paymentChannel.current]?.payAmount.length === 2">
                                <div class="inputMoney flex alignItemsCenter">
                                    <span class="font22">{{goldUnit()}}</span>
                                    <input @input="rounding" v-model="formData.money"
                                           :placeholder="`${l('qsr')}${paymentChannel.list[paymentChannel.current]?.label}${l('y2')}`"
                                           class="flex1 font16" type="number">
                                    <div @click="autoMoney"
                                         class="font14 hover pointer flex alignItemsCenter justifyContentCenter">
                                        {{l('zdje')}}
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div style="margin:15px 0px;height: 1px;background-color: #e6e2dd;"></div>
                        <p class="font16" style="color:#39270c;margin-top:30px;">{{l('cubz')}}</p>
                        <div style="margin-top: 20px;">
                            <div class="inputMoney flex alignItemsCenter">
                                <span class="font22" style="visibility: hidden;">{{goldUnit()}}</span>
                                <input v-model="formData.remark"
                                       :placeholder="paymentMethod[currentPaymentMethod]?.hintText"
                                       class="flex1 font16" type="text">
                            </div>
                        </div>
                        <div @click="submitBtnFn"
                             class="submitBtn font18 colorfff pointer hover flex alignItemsCenter justifyContentCenter">
                            <span>{{l('ljck')}}</span>
                        </div>
                    </div>
                    <div class="shortcuts font14 flex justifyContentSpaceBetween alignItemsCenter">
                        <p class="textAlignCenter hover pointer">{{l('cqjl')}}</p>
                        <p>{{l('czydwt')}}<span @click="toOnlineService" class="hover pointer">{{l('lxkf')}}</span>{{l('jj')}}
                        </p>
                    </div>
                </div>
            </template>
        </UseDialog>
    </div>
</template>

<script>
    import {mapState} from "vuex"

    import {getPayTagApi, getPayChannelApi, gameApiPayApi} from "@/api"

    export default {
        name: "index",
        computed: {
            ...mapState(['showDeposit']),
        },
        data() {
            return {
                paymentMethod: [],   //支付方式集合
                currentPaymentMethod: '',//当前的支付方式 会采用方法changePayMentMethodFn 默认成0
                formData: {money: '', remark: ''},  //表单
                paymentChannel: {current: 0, list: []}, //支付渠道
                quickAmount: {current: 0},//快捷支付
                loading: false,
            }
        },
        watch: {
            showDeposit: {
                handler(newVal, oldVal) {
                    if (newVal) {
                        this.useInterceptedOnMounted(this.init)
                    }
                }, immediate: true
            }
        },
        methods: {
            init() {
                this.loading = true
                Promise.all([getPayTagApi(), getPayChannelApi()]).then(res => {
                    //失败拦截
                    if (res.filter(item => !item.data).length > 0) return

                    let res0 = res[0].data.result || []
                    let res1 = res[1].data.result || []

                    res0.forEach((item, index) => {
                        res1.forEach((l, i) => {
                            if (!item.child) item.child = []
                            if (l.tag === item.id) {
                                item.child.push(l)
                            }
                        })
                    })
                    this.paymentMethod = [...res0]
                    //默认选中第一项
                    this.changePayMentMethodFn(0)

                    setTimeout(() => {
                        this.loading = false
                    }, 300)
                })
            },
            closeCallBack() {
                this.setStoreState({prop: 'showDeposit', value: false})
            },
            changePayMentMethodFn(index) {  //切换支付方式
                this.currentPaymentMethod = index
                //清空金额
                this.formData.money = ''
                //更新支付通道
                this.paymentChannel = {
                    current: 0,
                    list: this.paymentMethod[index].child || []
                }
            },
            changePaymentChannelFn(index) { //切换支付渠道
                if (this.paymentChannel.current === index) return
                this.paymentChannel.current = index
                //清空金额
                this.formData.money = ''
            },
            quickAmountFn(num, index) {  //快捷金额方法
                this.quickAmount.current = index
                this.formData.money = num
            },
            autoMoney() {    //最大金额
                this.formData.money = this.paymentChannel.list[this.paymentChannel.current]?.label.split('-')[1]
            },
            async submitBtnFn() { //立即存款
                let {money: _money, remark: _remark} = this.formData
                let moneyMinToMax = this.paymentChannel.list[this.paymentChannel.current]?.label.split('-')
                if (!_money) {
                    this.$message({type: 'error', message: this.l('qsrckje')})
                    return
                }
                if (_money < Number(moneyMinToMax[0]) || _money > Number(moneyMinToMax[1])) {
                    this.$message({
                        type: 'error',
                        message: `${this.l('qsr')}${this.paymentChannel.list[this.paymentChannel.current]?.label}${this.l('y2')}`
                    })
                    return
                }
                if (!_remark) {
                    this.$message({type: 'error', message: this.l('qsrckbz')})
                    return
                }
                let _data = {
                    id: this.paymentChannel.list[this.paymentChannel.current].id,
                    amount: _money + '',
                    remark: _remark,
                    // payType: paymentChannel.list[paymentChannel.current].payType,
                    // mCode: paymentChannel.list[paymentChannel.current].mCode,
                }

                this.loading = true

                let gameApiPayApiResp = await gameApiPayApi(_data)

                this.loading = false

                if (!gameApiPayApiResp.data) return

                //跳转到支付页面
                const _this = this
                this.$confirm(this.l('ljzf'), this.l('ts'), {
                    confirmButtonText: this.l('ljzf'),
                    cancelButtonText: this.l('qx'),
                    type: 'success',
                    // center: true
                }).then(() => {
                    _this.formData.money = ''
                    _this.formData.remark = ''
                    window.open(gameApiPayApiResp.data.result)
                }).catch(() => {

                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .containerDeposit {
        .content {
            padding: 20px;

            .rechargeMethod {
                margin-top: 15px;

                P {
                    height: 40px;
                    margin-right: 15px;
                    margin-bottom: 15px;
                    padding: 0px 25px;
                    color: #39270c;
                    background: url("@images/deposit/bmhcz_bg.png") no-repeat center center/100% 100%;

                    &:hover {
                        color: #fff;
                        background: url("@images/deposit/usdtcz_bg.png") no-repeat center center/100% 100%;
                    }

                    &.currentRechargeMethod {
                        color: #fff;
                        background: url("@images/deposit/usdtcz_bg.png") no-repeat center center/100% 100%;
                    }
                }
            }

            .paymentChannels {
                padding: 25px;
                /*margin-top: 30px;*/
                background: url("@images/deposit/cunkuan_bg.png") no-repeat center center/100% 100%;

                .channels {
                    margin-top: 20px;

                    P {
                        height: 45px;
                        margin-right: 15px;
                        margin-bottom: 10px;
                        padding: 0px 50px;
                        color: #39270c;
                        background: url("@images/deposit/bmhcz_bg.png") no-repeat center center/100% 100%;

                        &:hover {
                            color: #fff;
                            background: url("@images/deposit/xzbz_trc20.png") no-repeat center center/100% 100%;
                        }

                        &.currentRechargeMethod {
                            color: #fff;
                            background: url("@images/deposit/xzbz_trc20.png") no-repeat center center/100% 100%;
                        }
                    }
                }

                .inputMoney {
                    > input {
                        margin: 0px 15px;
                    }

                    > div {
                        width: 88px;
                        height: 36px;
                        background-color: #ffffff;
                        border-radius: 18px;
                        border: solid 1px #b7874a;
                        color: #b7874a;
                    }
                }

                .chooseMoney {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr); /* 每行4个 */
                    /*grid-template-rows: repeat(5, 1fr);*/
                    gap: 10px 15px; /* 项目间的间隔 */

                    p {
                        height: 36px;
                        line-height: 36px;
                        background-color: #ffffff;
                        color: #b7874a;
                        border-radius: 9px;
                        border: solid 1px #b7874a;

                        &:hover {
                            color: #fff;
                            background-image: linear-gradient(0deg,
                                    #ae7d3f 13%,
                                    #fcd799 100%),
                            linear-gradient(
                                            #e9f3fd,
                                            #e9f3fd);
                            background-blend-mode: normal,
                            normal;
                            box-shadow: inset 0px -2px 4px 0px rgba(255, 250, 245, 0.54);
                        }

                        &.currentMoney {
                            color: #fff;
                            background-image: linear-gradient(0deg,
                                    #ae7d3f 13%,
                                    #fcd799 100%),
                            linear-gradient(
                                            #e9f3fd,
                                            #e9f3fd);
                            background-blend-mode: normal,
                            normal;
                            box-shadow: inset 0px -2px 4px 0px rgba(255, 250, 245, 0.54);
                        }
                    }
                }

                .submitBtn {
                    height: 50px;
                    margin-top: 35px;
                    background: url("@images/deposit/ck_ljck.png") no-repeat center center/100% 100%;
                }
            }

            .shortcuts {
                margin-top: 15px;

                p:first-child {
                    width: 85px;
                    height: 33px;
                    line-height: 33px;
                    background-color: #eae4dc;
                    border-radius: 17px;
                    color: #b7874a;
                }

                p:nth-child(2) {
                    color: #aea28e;

                    span {
                        color: #b7874a;
                    }
                }
            }
        }
    }
</style>
